module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Bold.92fe0f3f.woff2";